<template>
  <template v-if="Object.hasOwn(result, block.slug) && shopMaterials">
    <ProductMaterialRoundView
      v-if="!block.view_type || block.view_type === filterViewType.round"
      :title="block.currentTranslation.title"
      :selected-item="result[block.slug]"
      :block="block"
      :label-class="labelClass"
      :skip-disable="skipDisable"
      @filter="onFilterClick"
    >
      <template #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            !hideLearnMoreLink &&
            (block.sku === stoneTypeSku ||
              block.sku === propertiesGroupSkus.stoneType)
          "
          :title="block.currentTranslation.title"
        />
        <slot name="additional" :block="block" />
      </template>
    </ProductMaterialRoundView>
    <ProductMaterialTileView
      v-else-if="block.view_type === filterViewType.icon"
      :title="block.currentTranslation.title"
      :selected-item="result[block.slug]"
      :block="block"
      :label-class="labelClass"
      :is-regular-pdp="isRegularPdp"
      :skip-disable="skipDisable"
      @filter="onFilterClick"
    >
      <template #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            !hideLearnMoreLink &&
            (block.sku === stoneTypeSku ||
              block.sku === propertiesGroupSkus.stoneType)
          "
          :title="block.currentTranslation.title"
        />
        <slot name="additional" :block="block" />
      </template>
    </ProductMaterialTileView>
    <ProductMaterialButtonView
      v-else-if="
        block.view_type === filterViewType.button ||
        block.view_type === filterViewType.button_big
      "
      :title="block.currentTranslation.title"
      :selected-item="result[block.slug]"
      :block="block"
      :label-class="labelClass"
      :skip-disable="skipDisable"
      @filter="onFilterClick"
    >
      <template #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            !hideLearnMoreLink &&
            (block.sku === stoneTypeSku ||
              block.sku === propertiesGroupSkus.stoneType)
          "
          :title="block.currentTranslation.title"
        />
        <slot name="additional" :block="block" />
      </template>
    </ProductMaterialButtonView>
    <ProductMaterialCheckboxView
      v-else-if="block.view_type === filterViewType.checkbox"
      :title="block.currentTranslation.title"
      :selected-item="result[block.slug]"
      :block="block"
      :label-class="labelClass"
      :skip-disable="skipDisable"
      @filter="onFilterClick"
    >
      <template #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            !hideLearnMoreLink &&
            (block.sku === stoneTypeSku ||
              block.sku === propertiesGroupSkus.stoneType)
          "
          :title="block.currentTranslation.title"
        />
        <slot name="additional" :block="block" />
      </template>
    </ProductMaterialCheckboxView>
    <ProductMaterialSelectView
      v-else-if="block.view_type === filterViewType.select"
      :title="block.currentTranslation.title"
      :selected-item="result[block.slug]"
      :block="block"
      :label-class="labelClass"
      :skip-disable="skipDisable"
      @filter="onFilterClick"
    >
      <template #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            !hideLearnMoreLink &&
            (block.sku === stoneTypeSku ||
              block.sku === propertiesGroupSkus.stoneType)
          "
          :title="block.currentTranslation.title"
        />
        <slot name="additional" :block="block" />
      </template>
    </ProductMaterialSelectView>
  </template>
  <template
    v-else-if="Object.hasOwn(additionalOptions, block.slug) && shopMaterials"
  >
    <ProductMaterialRoundView
      v-if="!block.view_type || block.view_type === filterViewType.round"
      :title="block.currentTranslation.title"
      :selected-item="additionalOptions[block.slug]"
      :block="block"
      :label-class="labelClass"
      :skip-disable="skipDisable"
      @filter="onOptionsFilterClick"
    >
      <template #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            !hideLearnMoreLink &&
            (block.sku === stoneTypeSku ||
              block.sku === propertiesGroupSkus.stoneType)
          "
          :title="block.currentTranslation.title"
        />
        <slot name="additional" :block="block" />
      </template>
    </ProductMaterialRoundView>
    <ProductMaterialTileView
      v-else-if="block.view_type === filterViewType.icon"
      :title="block.currentTranslation.title"
      :selected-item="additionalOptions[block.slug]"
      :block="block"
      :label-class="labelClass"
      :is-regular-pdp="isRegularPdp"
      :skip-disable="skipDisable"
      @filter="onOptionsFilterClick"
    >
      <template #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            !hideLearnMoreLink &&
            (block.sku === stoneTypeSku ||
              block.sku === propertiesGroupSkus.stoneType)
          "
          :title="block.currentTranslation.title"
        />
        <slot name="additional" :block="block" />
      </template>
    </ProductMaterialTileView>
    <ProductMaterialButtonView
      v-else-if="
        block.view_type === filterViewType.button ||
        block.view_type === filterViewType.button_big
      "
      :title="block.currentTranslation.title"
      :selected-item="additionalOptions[block.slug]"
      :block="block"
      :label-class="labelClass"
      :skip-disable="skipDisable"
      @filter="onOptionsFilterClick"
    >
      <template #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            !hideLearnMoreLink &&
            (block.sku === stoneTypeSku ||
              block.sku === propertiesGroupSkus.stoneType)
          "
          :title="block.currentTranslation.title"
        />
        <slot name="additional" :block="block" />
      </template>
    </ProductMaterialButtonView>
    <ProductMaterialCheckboxView
      v-else-if="block.view_type === filterViewType.checkbox"
      :title="block.currentTranslation.title"
      :selected-item="additionalOptions[block.slug]"
      :block="block"
      :label-class="labelClass"
      :skip-disable="skipDisable"
      @filter="onOptionsFilterClick"
    >
      <template #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            !hideLearnMoreLink &&
            (block.sku === stoneTypeSku ||
              block.sku === propertiesGroupSkus.stoneType)
          "
          :title="block.currentTranslation.title"
        />
        <slot name="additional" :block="block" />
      </template>
    </ProductMaterialCheckboxView>
    <ProductMaterialSelectView
      v-else-if="block.view_type === filterViewType.select"
      :title="block.currentTranslation.title"
      :selected-item="additionalOptions[block.slug]"
      :block="block"
      :label-class="labelClass"
      :skip-disable="skipDisable"
      @filter="onOptionsFilterClick"
    >
      <template #additional>
        <ProductMaterialLearnMoreLink
          v-if="
            !hideLearnMoreLink &&
            (block.sku === stoneTypeSku ||
              block.sku === propertiesGroupSkus.stoneType)
          "
          :title="block.currentTranslation.title"
        />
        <slot name="additional" :block="block" />
      </template>
    </ProductMaterialSelectView>
  </template>
</template>

<script setup lang="ts">
import { HTMLAttributes } from "vue";
import {
  FilteredMaterialsByCategoriesI,
  IProductConfigurationResult,
  IProductMaterialFilterEvent,
} from "ecom-types";
import { propertiesGroupSkus, sizesSlugs, stoneTypeSku } from "~/configs";

const props = defineProps<{
  block: FilteredMaterialsByCategoriesI;
  result: IProductConfigurationResult;
  additionalOptions: IProductConfigurationResult;
  labelClass?: HTMLAttributes["class"];
  hideLearnMoreLink?: boolean;
  showIfOnePropertyInList?: boolean;
  isRegularPdp?: boolean;
  skipDisable?: boolean;
}>();

const emit = defineEmits<{
  (e: "optionsFilter", value: IProductMaterialFilterEvent): void;
  (e: "filter", value: IProductMaterialFilterEvent): void;
}>();

const SizeMaterialCategory = computed(() => {
  return sizesSlugs.includes(props.block.slug);
});

const shopMaterials = computed(() => {
  return (
    props.showIfOnePropertyInList ||
    props.block.materials?.length > 1 ||
    SizeMaterialCategory.value
  );
});

function onOptionsFilterClick(value: IProductMaterialFilterEvent) {
  emit("optionsFilter", value);
}

function onFilterClick(value: IProductMaterialFilterEvent) {
  emit("filter", value);
}
</script>
